import { AuthProvider } from '@/context/AuthProvider'
import { LayoutProvider } from '@/context/useLayoutContext'
import { ChildrenType } from "@/types/component-props.ts";
import { CookiesProvider } from 'react-cookie';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

// Create a client instance
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      refetchOnWindowFocus: false,
    },
  },
});

const AppProvidersWrapper = ({ children }: ChildrenType) => {
  return (
    <CookiesProvider defaultSetOptions={{ path: '/' }}>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <LayoutProvider>
            {children}
          </LayoutProvider>
        </AuthProvider>
      </QueryClientProvider>
    </CookiesProvider>
  )
}

export default AppProvidersWrapper